import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FileBox } from 'src/components/basic';
import { popupModel, SlideMedia } from 'src/components/complex/index';

import { getFileInfoFromUri, useScreenDetail } from 'src/helpers';

export const MediaGroup = ({
  images,
  template = 1,
  length: lengthProps = 3,
  maxImgWidth,
  maxImgHeight,
  aspect = 1,
  onViewEdit,
  mainStyle = {},
  enableEvent = false
}) => {
  const media = images.map(getFileInfoFromUri);
  const [clientWidth, setClientWidth] = useState(0);
  const container = useRef();
  const screen = useScreenDetail();

  useEffect(() => {
    setClientWidth(container.current?.clientWidth || 0);
  }, [container, screen]);

  let gap = 10;
  let mainWidth = maxImgWidth || clientWidth;
  let mainHeight = maxImgHeight || 'auto';
  let width = (mainWidth - gap * 2) / 3;
  let height = width * 1.2;
  let length = lengthProps;
  let childStyle = {};

  if (template === 2) {
    mainWidth = Math.min(400, clientWidth) / 2 - gap;
    mainHeight = Math.min(400, clientWidth) / 2;
    width = (mainWidth - gap) / 2;
    height = (mainHeight - gap) / 2;
  }

  if (template === 4) {
    gap = 20;
    mainWidth = clientWidth - 20;
    mainHeight = mainWidth;
    width = (clientWidth - gap * 2) / 3;
    height = width;
  }

  if (template === 5) {
    mainWidth = maxImgWidth || 200;
    width = (mainWidth - gap) / 2;
    if (width > (clientWidth - 2 * gap) / 3) {
      width = (clientWidth - 2 * gap) / 3;
      mainWidth = width * 2 + gap;
      length = 2;
    } else {
      length = Math.floor((clientWidth - mainWidth) / (width + gap / 2));
      if (length * (width + gap) + mainWidth > clientWidth) {
        length -= 1;
      }
      length *= 2;
    }
    childStyle.minWidth = width;
    mainHeight = maxImgHeight || mainWidth;
    height = (mainHeight - gap) / 2;
  }

  if (template === 6) {
    width = (clientWidth - gap * (lengthProps - 1)) / lengthProps;
    if (maxImgWidth) width = Math.min(width, maxImgWidth);
    height = width / aspect;
    length = lengthProps - 1;
    mainWidth = width;
    mainHeight = height;
  }

  childStyle.height = height;
  childStyle.width = width;

  const imgs = [];

  const click = useCallback(
    () =>
      popupModel.setActivePopup('slide_image', {
        active: true,
        component: SlideMedia,
        props: {
          media,
          onViewEdit,
          selectedIndex: 0,
          enableEvent: true
        }
      }),
    [media, onViewEdit]
  );

  for (let i = 1; i < Math.min(length + 1, media.length); i++) {
    let hasMore = i === length && media.length > length + 1;
    imgs.push(
      <div className={'image-group-content'} key={i} style={childStyle}>
        {hasMore && (
          <div className={'mc-cover has-more'} onClick={click}>
            {hasMore && '+' + (media.length - length - 1)}
          </div>
        )}
        <FileBox
          template={3}
          list={media}
          file={media[i]}
          fileIndex={i}
          onViewEdit={onViewEdit}
          onClose={null}
          styles={{ width, height }}
          onlyPreview={true}
          showFileName={false}
          enableEvent={enableEvent}
        />
      </div>
    );
  }

  if ((template === 4 || template === 1) && imgs.length < length && imgs.length > 0)
    imgs.push(<div key={100} style={{ width, height }} />);

  return (
    <div className={'mc-image-group template-' + template} ref={(ref) => (container.current = ref)}>
      <div className={'mc-main'} style={{ flex: 0, minWidth: mainWidth, ...mainStyle }}>
        <FileBox
          template={3}
          list={media}
          file={media[0]}
          fileIndex={0}
          onClose={null}
          styles={{
            width: mainWidth,
            height: mainHeight,
            objectFit: 'container'
          }}
          onlyPreview={true}
          showFileName={false}
          onViewEdit={onViewEdit}
          enableEvent={enableEvent}
        />
      </div>
      {width > 0 && (
        <div className={'mc-image-group-group'} style={{ gap }}>
          {imgs}
        </div>
      )}
    </div>
  );
};
